import { gql } from '@apollo/client';

import { interactiveLessonSectionFragment } from './lesson-builder.graphql';

export const DUPLICATE_ACTIVITIES_SECTION = gql`
  mutation DuplicateActivitiesSection(
    $input: DuplicateActivitiesSectionInput!
  ) {
    duplicateActivitiesSection(input: $input) {
      ...InteractiveLessonSectionFragment
    }
  }
  ${interactiveLessonSectionFragment}
`;

export const DUPLICATE_ACTIVITIES_SUB_SECTION = gql`
  mutation DuplicateActivitiesSubSection(
    $input: DuplicateActivitiesSubSectionInput!
  ) {
    duplicateActivitiesSubSection(input: $input) {
      ...InteractiveLessonSectionFragment
      parentSectionId
    }
  }
  ${interactiveLessonSectionFragment}
`;

export const DUPLICATE_ACTIVITIES_SUB_SECTION_AS_SECTION = gql`
  mutation DuplicateActivitiesSubSectionAsSection(
    $input: DuplicateActivitiesSubSectionAsSectionInput!
  ) {
    duplicateActivitiesSubSectionAsSection(input: $input) {
      ...InteractiveLessonSectionFragment
    }
  }
  ${interactiveLessonSectionFragment}
`;

export const DUPLICATE_ACTIVITIES_SECTION_AS_SUB_SECTION = gql`
  mutation DuplicateActivitiesSectionAsSubSection(
    $input: DuplicateActivitiesSectionAsSubSectionInput!
  ) {
    duplicateActivitiesSectionAsSubSection(input: $input) {
      ...InteractiveLessonSectionFragment
      parentSectionId
    }
  }
  ${interactiveLessonSectionFragment}
`;
